module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABPElEQVRIS92WYVEDQQyF31NAJYACigMcgANwQFEAKKA4aB2AAxxAHVRCq+Ax72aPubZ7vc2WoQP5uZfst0leMkf8kjHHkXQK4BnAdfAdrwDuSS634/pAkwQKchp3g6aloEcADzUUAE8kHb9hfRkdBbQGsFOKrQe71CfprDqjOcnbfWWUNANwcygo2qrqjP4gSJKbaTmPSFJSV3VvJPcOriQP6lW3R5IEYJXkPm3kLckHjWoyIH8rUd0oA/LRkuRZCzK9sQyoqkcpo+87jw46eNeVZuTt7QafB+u28Mb39h4EAbgg+RkEbLhLGgP46PZ9p0dWScrGaqsxq8/j4Kr0i6Hm5qEYKzmX0VBc+Pv/BlllUSmXlnBBctz2yLvsrjQy6PdCctKCLElv7MsfzMzD++57Sa6yPyfBFxe5fwHJyL8bdJnFcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_printff.png
// module id = 4XKm
// module chunks = 1